import dictionaryService from "../../../api/dictionary.api";
import { useEffect, useState } from "react";
import { IDictionaryItem } from "../../../types/IDictionaryItem";

export enum DICTIONARY_ITEMS {
    PRIVILEGE = "privilege",
    REASON_FOR_HIRING = "reasonForHiring",
    WORK_CONTRACT_TYPE = "workContractType",
    LANGUAGE = "language",
    LANGUAGE_DEGREE = "languageDegree",
    DEPARTMENT = "department",
    ENGLISH_LEVEL = "englishLevel",
    EDUCATION_DEGREE = "educationDegree",
    WORK_SCHEDULE_TYPE = "workScheduleType",
    WORK_EXPERIENCE_TYPE = "workExperienceType",
    PERSONAL_QUALITY = "personalQuality",
    BONUS_TYPE = "bonusType"
}

export type DictionariesState = {
    privilege: IDictionaryItem[];
    personalQuality: IDictionaryItem[];
    reasonForHiring: IDictionaryItem[];
    workContractType: IDictionaryItem[];
    department: IDictionaryItem[];
    divisions: IDictionaryItem[];
    englishLevel: IDictionaryItem[];
    educationDegree: IDictionaryItem[];
    workScheduleType: IDictionaryItem[];
    workExperienceType: IDictionaryItem[];
    languages: IDictionaryItem[];
    languageDegrees: IDictionaryItem[];
    bonusTypes: IDictionaryItem[];
};

const getDictionaryKey = (key: DICTIONARY_ITEMS): keyof DictionariesState => {
    switch (key) {
        case DICTIONARY_ITEMS.BONUS_TYPE:
            return "bonusTypes";
        case DICTIONARY_ITEMS.LANGUAGE:
            return "languages";
        case DICTIONARY_ITEMS.LANGUAGE_DEGREE:
            return "languageDegrees";
        default:
            return key as keyof DictionariesState;
    }
};


export const useDictionaries = (vacancyCompanyId: number | null, dictionariesTypes?: DICTIONARY_ITEMS[]) => {
    const [dictionaries, setDictionaries] = useState<DictionariesState>({
        privilege: [],
        personalQuality: [],
        reasonForHiring: [],
        workContractType: [],
        department: [],
        divisions: [],
        englishLevel: [],
        educationDegree: [],
        workScheduleType: [],
        workExperienceType: [],
        languages: [],
        languageDegrees: [],
        bonusTypes: []
    });

    useEffect(() => {
        const fetchDictionaries = async (vacancyCompanyId: number | null) => {
            const typesToLoad = dictionariesTypes?.length ? dictionariesTypes : Object.values(DICTIONARY_ITEMS);

            const requests = typesToLoad.map((key) =>
                dictionaryService.findAll(key, vacancyCompanyId).then((response) => ({ key, data: response.data }))
            );

            const results = await Promise.all(requests);

            const newDictionaries = results.reduce<Partial<DictionariesState>>((acc, { key, data }) => {
                const dictionaryKey = getDictionaryKey(key);
                acc[dictionaryKey] = data;
                return acc;
            }, {});

            setDictionaries((prev) => ({ ...prev, ...newDictionaries }));
        };

        fetchDictionaries(vacancyCompanyId);
    }, [vacancyCompanyId]);

    return { dictionaries, setDictionaries };
};
